import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Stack, Box, Typography, Divider, } from '@mui/material';
const StyledDivider = styled(Divider)(() => ({
    borderBottomWidth: 3,
    margin: '16px 1px 0px',
}));
const PanelTitle = ({ title, startIcon, endIcon, rootStyle, wrapperStyle, dividerStyle, className, }) => (_jsxs(Box, { sx: { mb: 3.25, ...rootStyle }, children: [_jsxs(Stack, { sx: { ...wrapperStyle }, direction: "row", justifyContent: "space-between", children: [_jsxs(Stack, { direction: "row", spacing: 1, children: [startIcon, _jsx(Typography, { component: "div", variant: "h3", fontWeight: "fontWeightBold", sx: { marginY: 'auto !important' }, className: className || 'landingpage-section-header', children: title })] }), endIcon] }), _jsx(StyledDivider, { sx: { ...dividerStyle } })] }));
PanelTitle.defaultProps = {
    startIcon: null,
    endIcon: null,
    rootStyle: {},
    wrapperStyle: {},
    dividerStyle: {},
    className: null,
};
export default PanelTitle;
//# sourceMappingURL=PanelTitle.js.map